// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListThumbnailMissingImage_wrapper__6U4c1"};